import * as React from "react";

function IcSystemStatusFailFill12(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 12,
    height = 12,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemStatusFailFill12"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_5242_676)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM4.53033 3.46967C4.23744 3.17678 3.76256 3.17678 3.46967 3.46967C3.17678 3.76256 3.17678 4.23744 3.46967 4.53033L4.93934 6L3.46967 7.46967C3.17678 7.76256 3.17678 8.23744 3.46967 8.53033C3.76256 8.82322 4.23744 8.82322 4.53033 8.53033L6 7.06066L7.46967 8.53033C7.76256 8.82322 8.23744 8.82322 8.53033 8.53033C8.82322 8.23744 8.82322 7.76256 8.53033 7.46967L7.06066 6L8.53033 4.53033C8.82322 4.23744 8.82322 3.76256 8.53033 3.46967C8.23744 3.17678 7.76256 3.17678 7.46967 3.46967L6 4.93934L4.53033 3.46967Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5242_676">
          <rect width={12} height={12} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IcSystemStatusFailFill12;
